import styled from 'styled-components';

export const StyledGameViewFacilitator = styled.div`

`;

export const StyledTeams = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const StyledTeamPoints = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
`;

export const StyledGameControls = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  
`;